import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionsService } from 'src/app/services/permissions.service';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent {
    isCollapsed = false;
    panelOpenState = false;
    env = environment;

    appName = environment.config.appName;
    appNameSmall = environment.config.appNameSmall;
    appDescription = environment.config.appDescription;
    appDescriptionSmall = environment.config.appDescriptionSmall;
    appLogoUrl = environment.config.appLogoUrl;
    activeOption = '';

    constructor(private router: Router, private storageService: StorageService, public permissionsService: PermissionsService) {
        this.activeOption = router.url;
        this.onResize();
    }

    setActive(value: string) {
        this.activeOption = value;
    }

    logout() {
        this.storageService.clear();
        window.location.href = environment.interop.authCore.linkRedirectAuth;
    }

    redirectToinDeskPlatform() {
        window.location.href = environment.interop.authCore.linkRedirectAuth;
    }

    toggleSidebar() {
        this.isCollapsed = !this.isCollapsed;
    }

    hasAnySettingsPermission(): boolean {
        const settingsPermissions = [
            'indoc-module.settings.general-settings.list',
            'indoc-module.settings.tipuri-access.list',
            'indoc-module.settings.priorities.list',
            'indoc-module.settings.statuses.list',
            'indoc-module.settings.tipuri-documente-registratura.list',
            'indoc-module.settings.serii-documente.list',
            'indoc-module.settings.surse-documente.list',
            'indoc-module.settings.entities.list',
            'indoc-module.settings.finalizare-documente.list',
            'indoc-module.settings.template-documente.list',
            'indoc-module.settings.categorii-template.list',
            'indoc-module.settings.free-days.list',
            'indoc-module.settings.tipuri-documente.list',
            'indoc-module.settings.inbox-adrese-redirectionare.list',
            'indoc-module.settings.institutii-servicii-registre-active.list',
            'indoc-module.settings.inbox-blacklist.list',
            'indoc-module.settings.operatori.list'
        ];

        return settingsPermissions.some(permission =>
            this.permissionsService.hasPermission(permission)
        );
    }

    hasAnyAdministrativeSettingsPermission(): boolean {
        const administrativeSettingsPermissions = [
            'indoc-module.administrative.configurations.list',
            'indoc-module.administrative.storage-locations.list',
            'indoc-module.administrative.crons.list',
        ];

        return administrativeSettingsPermissions.some(permission =>
            this.permissionsService.hasPermission(permission)
        );
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.isCollapsed = window.innerWidth < 960;
    }
}
